// 服务订阅状态说明
export default {
  0: '审批中',
  1: '已同意',
  2: '已拒绝',
  3: '已撤销',
  4: '已禁用',
  5: '已删除',
  6: '已取消授权',
};
